<template>
	<div id="common" style="background-color: #f2f2f2;">
		
		<el-container>
			<!-- 头部 -->
			<el-header style="height: 10rem;">
				<div class="header">
					<div class="header-div">
						<div class="left">
							<img class="imgss" @mouseenter="mouseaEnter(1)" v-show="show==0" :src="avatar" />
							<div class="bagimg" v-show="show==1" @mouseleave="mouseaLeave">
								<img :src="circleUrl" />
								<el-upload
								  class="avatar-uploader3 shang"
								  action="http://2.silubei.com/api/v1/upload"
								  :show-file-list="false"
								  :on-success="handleAvatarSuccess"
								  :before-upload="beforeAvatarUpload">
									<div>点击上传</div>
									
								</el-upload>
								
							</div>
							<!-- <el-avatar :size="50" :src="circleUrl"></el-avatar> -->
							<div class="div">
								<div class="div1">{{info.username}}</div>
								<div class="div2">
									<div>
										<img src="../../../assets/shudo/images/u21.png" />
										<span>{{info.nationality}}|{{info.city}}</span>
									</div> 
									<div>
										<img src="../../../assets/shudo/images/u20.png" />
										<span>{{info.label}}</span>
									</div>
								</div>
								<!-- <div class="div3">{{info.label}}</div> -->
							</div>
							
						</div>
						<div class="right">
							<!-- <div class="right1">
								<div class="right2">
									<div>2</div>
									<div>关注</div>
								</div>
								<div class="right2">
									<div>2</div>
									<div>关注</div>
								</div>
								<div class="right2">
									<div>2</div>
									<div>关注</div>
								</div>
							</div> -->
							<div class="right3" @click="url('/centre')">编辑资料</div>
						</div>
					</div>
				</div>
			</el-header>  
			<div style="height: 1rem;"></div>
			<el-container style="width: 80%;  margin: auto; padding-bottom:6rem">
				<el-aside width="9rem">
					<div style="height: 0.5rem; border: none;"></div>
					<div :class="type=='/question'?'lefttype':''" @click="url('/question')">我的题库</div>
					<div :class="type=='/competition'?'lefttype':''" @click="url('/competition')">我的赛事</div>
					<!-- <div :class="type=='/bean'?'lefttype':''" @click="url('/bean')">我的粉丝</div> -->
					<!-- <div :class="type=='/attention'?'lefttype':''" @click="url('/attention')">我的关注</div> -->
					<div :class="type=='/tixing'?'lefttype':''" @click="url('/tixing')">我的题型</div>
					<div :class="type=='/dingyue'?'lefttype':''" @click="url('/dingyue')">我的订阅</div>
					<!-- <div>我的收藏</div> -->
					<div :class="type=='/authentication'?'lefttype':''" @click="url('/authentication')">认证中心</div>
					<div :class="type=='/centre'?'lefttype':''" @click="url('/centre')">资料设置</div>
					<div :class="type=='/updpass'?'lefttype':''" @click="url('/updpass')">密码设置</div>
					<!-- <div>通知中心</div> -->
					<div style="border: none;" @click="quit()">退出</div>
				</el-aside>	 
				
				<el-main>
					
					
					<router-view></router-view>   
				</el-main>
			</el-container>
		</el-container>
		
	</div>
	
	


</template>

<script>
	export default {
	    data() {
			return {
				type : '/question',
				info : [],
				circleUrl : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
				show  : 0,
				avatar : 'http://cccss.oss-cn-beijing.aliyuncs.com/uploads/8.svg'
			}
	    },
		created() {
			let that  = this;
			that.$http('get','/api/v1/user/user_info',{}) .then(function (res) {
				that.info   = res.data;
				that.avatar = res.data.avatar;
			});	
		},
		methods:{
			handleAvatarSuccess(res, file) {
				let that = this;
				that.avatar  = res.data;
				that.$http('post','/api/v1/user/avatar',{avatar:res.data}) .then(function (ress) {
					that.$message({
						type: 'success',
						message: '修改成功!'
					});
				});
				
				console.log(res)
			},
			mouseaEnter(e){
				console.log(1);
				this.show  = e;
			},
			mouseaLeave(){
				let that = this;
				console.log(22);
				setTimeout(function () {
				    that.show=0;
				},200);
			},
			url(e){
				this.$router.push(e);
				this.type = e;
			},
			quit(){
				let that = this;
				this.$confirm('是否退出登录?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					that.$http('post','/api/v1/userlogin/quit',{}) .then(function (res) {
						that.$message({
							type: 'success',
							message: '退出登录成功!'
						});
						localStorage.token = '';
						that.info  =  [];
						that.$router.push('/');	
					});
				  
				});
			}
		},
	}
	
</script>

<style lang="less">
	.el-header {
		height: 10rem;
		padding: 0;
	}
	.lefttype {
		color: #3d3e40 !important;
		font-size: 0.86rem !important;
	}
	.header {
		color: #FFFFFF;
		background-color: rgba(9, 7, 35, 1);
		width: 100%;
		height: 10rem;
		.header-div {
			width: 70%;
			margin: auto;
			display: flex;
			padding-top: 2rem;
			.left {
				flex: 2;
				display: flex;
				img {
					width: 5rem;
				}
				.div {
					padding-left: 1.6rem;
					.div1 {
						font-size: 1rem;
						font-weight: 600;
						padding-top: 1rem;
					}
					.div2 {
						padding-top: 0.6rem;
						font-size: 0.6rem;
						display: flex;
						div {
							
							img {
								width: 1rem;
								position: relative;
								top: 0.2rem;
							}
							span {
								padding-left: 0.4rem;
							}
						}
						div:nth-last-child(1){
							margin-left: 0.6rem;
						}
						
					}
					.div3 {
						position: relative;
						top: 1rem;
						font-size: 0.6rem;
					}
				}
				
			}
			.right {
				flex: 1;
				padding-top: 1.4rem;
				.right1 {
					display: flex;
					font-size: 0.6rem;
					.right2 {
						width: 2rem;
						text-align: center;
						line-height: 1.2rem;
					}
				}
				.right3 {
					position: relative;
					top: 0.8rem;
					left: 0.3rem;
					width: 5.4rem;
					text-align: center;
					height: 1.6rem;
					background-color: #FFFFFF;
					color: #000000;
					line-height: 1.6rem;
					border-radius: 0.4rem;
					font-size: 0.6rem;
				}
				
			}
		}
	}
	.el-aside {
		margin-left: 1rem;
		height:23.5rem;
		div {
			font-size: 0.6rem;
			width: 100%;
			height: 2rem;
			line-height: 2rem;
			border-bottom: 1px solid #e9e9e9 ;
			color: #7F7F7F;
		}
	}
	.bagimg {
		.shang {
			position: relative;
			background-color: #1b1a1a66;
			width: 81px;
			height: 82px;
			top: -83px;
			border-radius: 50px;
			text-align: center;
			line-height: 82px;
			color: #d1d1d4;
		}
	}
	.imgss {
		border-radius: 3.125rem;
	}
	
</style>
